<template>
    <div class="event">
      <q-tabs v-model="tab" dense class="text-grey top-tabs" align="justify" narrow-indicator>
        <q-tab name="all-events" label="All Events"/>
        <q-tab name="events-scores" label="Events Scores"/>
      </q-tabs>

      <q-separator/>

      <q-tab-panels class="fit" v-model="tab" animated>
        <q-tab-panel name="all-events">
          <loading v-if="loading"></loading>
          <div class="row" v-else>
            <div class="col-xs-12 col-sm-6 col-md-4 event-item" v-for="(item, index) in mySubscriptions"
                 :key="item.id">
              <div class="event-item-body">
                <div class="event-item-img">
                  <img :src="item.image">
                  <div class="event-overlay"></div>
                  <!-- End Event -->
                  <div class="end-in">
                    <span>End In</span>

                    <q-badge class="badge-rounded-item" rounded color="orange">
                      {{item.end_date}}
                    </q-badge>

                  </div>
                </div>
                <div class="content">
                  <div class="event-item-text">
                    <p class="head">{{ item.title }}</p>
                    <p class="text">{{ item.description }} </p>
                  </div>
                  <div class="event-item-footer">
                    <div class="footer-item">
                      <div>
                        <i class="fas fa-play-circle"></i>
                        <span>{{ item.start_date }}</span>
                      </div>
                      <div>
                        <i class="fas fa-hourglass-end"></i>
                        <span>{{ item.end_date }}</span>
                      </div>
                    </div>

                    <div class="footer-item">

                    </div>

                    <div class="the-button">
                      <button @click="toggele_model(item)" class="wro-button secondaryButtons">
                        <span>Start Now</span></button>
                      <span class="skew-line-w"></span>
                    </div>


                    <!-- menu -->
                    <q-btn class="dots-menu-button" icon="fas fa-ellipsis-v" flat>
                      <q-menu content-class="dots-menu">
                        <q-list style="min-width: 100px">
                          <q-item clickable v-close-popup>
                            <q-item-section @click="unSubscribe(item.Subscription_id)">
                              UnSubscribe
                            </q-item-section>
                          </q-item>
                          <q-separator/>
                        </q-list>
                      </q-menu>
                    </q-btn>
                  </div>
                </div>
              </div>
            </div>

            <div class="no-item-yet event-item-body" v-if="mySubscriptions.length === 0">No events yet</div>

            <!-- Event Round Model -->
            <div class="rounds-models">
              <q-dialog class="" v-model="round_model">
                <div class="wrapper">
                  <p class="f-s-32 text">Rounds </p>
                  <div class="container">
                    <div class="">
                      <ul class="Container-progessbar">
                        <li class="none"><span></span></li>
                        <li v-for="item in round_playing" :key="item.id"
                            :class="{'active': item}"></li>

                        <li class="none"></li>
                      </ul>
                    </div>
                    <!-- Medal -->
                    <div class="row Medal">
                      <div class="col-sm-6 col-md-4" v-for="(item,index) in target_event"
                           :key="item.id"
                           :class="{'active_event' :  round_playing[index] } ">
                        <div class="item">
                          <div class="the-img">
                            <img src="@/assets/img/event/group_27229.png">
                          </div>
                          <p class="the-text"> {{ item.start_time }} - {{ item.end_time }} 
                            {{item.date}}</p>
                        </div>
                      </div>
                    </div>

                    <!-- Text -->
                    <p class="text-details">
                      It Is A Non-Profit Organization. All Are Invested Proceeds From Sponsorships
                      And Fees To Support Our Mission, Which Is To Strengthen Robots
                    </p>

                    <div class="the-button">
                      <button class="wro-button secondaryButtons"
                              @click="redirect_to_game_page()"><span>Play Now</span>
                      </button>
                      <span class="skew-line-w"></span>
                    </div>
                  </div>
                </div>
              </q-dialog>
            </div>
          </div>
        </q-tab-panel>

        <q-tab-panel class="events-scores" name="events-scores">
          <div class="row">
            <div class="col-12 col-md-6 mb-15" v-for="(score, i) in scores" :key="i">
              <div class="score-card">
                <div class="top-part">
                  <div class="img-wrapper">
                    <img :src="score.image" alt="">
                  </div>
                  <div class="score-sub-details">
                    <h6>{{score.title}}</h6>
                    <p>{{score.description}}</p>

                    <q-tabs v-model="model['event' + score.event_id]">
                      <q-tab v-for="round in score.rounds" :key="round['playerOne'].round"
                             :name="'round' + round['playerOne'].round" :label="'Round ' + round['playerOne'].round"/>
                    </q-tabs>
                  </div>
                </div>
                <q-tab-panels class="round-details" v-model="model['event' + score.event_id]" animated>
                  <q-tab-panel v-for="round in score.rounds" :key="round['playerOne'].round"
                               :name="'round' + round['playerOne'].round">
                    <div class="row">
                      <div class="col-4 round-details-title">
                        <svg id="name-icon" viewBox="0 0 18.203 24.274">
                          <path id="Color"
                                d="M16.905,24.274a1.326,1.326,0,0,1-1.3-1.348,6.634,6.634,0,0,0-6.5-6.743,6.633,6.633,0,0,0-6.5,6.743,1.327,1.327,0,0,1-1.3,1.348A1.326,1.326,0,0,1,0,22.926a9.287,9.287,0,0,1,9.1-9.44,9.287,9.287,0,0,1,9.1,9.44A1.327,1.327,0,0,1,16.905,24.274ZM9.1,10.789a5.307,5.307,0,0,1-5.2-5.4A5.307,5.307,0,0,1,9.1,0a5.307,5.307,0,0,1,5.2,5.394A5.307,5.307,0,0,1,9.1,10.789ZM9.1,2.7A2.653,2.653,0,0,0,6.5,5.4,2.653,2.653,0,0,0,9.1,8.1a2.653,2.653,0,0,0,2.6-2.7A2.653,2.653,0,0,0,9.1,2.7Z"
                                transform="translate(0.001)" fill="#252634"/>
                        </svg>
                        Name
                      </div>
                      <div class="col-4">{{ round['playerOne'].playerOneName}}</div>
                      <div class="col-4">{{ round['playerTwo'].playerTwoName}}</div>
                    </div>
                    <div class="row" v-for="(score, scoreIndex) in round['playerOne'].scores" :key="scoreIndex">
                      <div class="col-4 round-details-title">
                        <svg id="score-icon" viewBox="0 0 21.848 14.565">
                          <path id="Color"
                                d="M21.838,1.169a1.069,1.069,0,0,0-.051-.254A1.149,1.149,0,0,0,21.73.709a1.05,1.05,0,0,0-.117-.172A1.189,1.189,0,0,0,21.45.328C21.44.317,21.435.3,21.423.293a1.128,1.128,0,0,0-.144-.081,1.224,1.224,0,0,0-.227-.127,1.218,1.218,0,0,0-.245-.049A1.141,1.141,0,0,0,20.634,0H14.565a1.214,1.214,0,0,0,0,2.427H18L13.1,8.142,7.907,5.028a1.21,1.21,0,0,0-1.557.263L.281,12.574a1.214,1.214,0,1,0,1.866,1.554l5.4-6.484,5.177,3.107A1.214,1.214,0,0,0,14.27,10.5l5.15-6.006V7.282a1.214,1.214,0,1,0,2.427,0V1.214a.363.363,0,0,0-.01-.045"
                                transform="translate(0 0)" fill="#252634"/>
                        </svg>
                        Score
                      </div>
                      <div class="col-4">{{score}}</div>
                      <div class="col-4">{{round['playerTwo'].scores[scoreIndex]}}</div>
                    </div>
                    <div class="row">
                      <div class="col-4 round-details-title">
                        <svg id="name-icon" viewBox="0 0 16.988 24.284">
                          <path id="Color"
                                d="M15.778,24.274a1.206,1.206,0,0,1-.588-.152L8.3,20.309l-6.469,3.8a1.23,1.23,0,0,1-.616.166A1.211,1.211,0,0,1,.042,22.76l2.8-10.9a7.282,7.282,0,1,1,11.311,0l2.8,10.9a1.213,1.213,0,0,1-.433,1.263,1.226,1.226,0,0,1-.742.251ZM8.277,17.7a1.226,1.226,0,0,1,.59.152L13.9,20.636l-1.8-7.03a7.236,7.236,0,0,1-7.2,0l-1.782,6.93,4.549-2.67a1.19,1.19,0,0,1,.61-.166ZM8.5,2.427a4.855,4.855,0,1,0,4.856,4.856A4.855,4.855,0,0,0,8.5,2.427Z"
                                transform="translate(-0.003 0.009)" fill="#252634"/>
                        </svg>

                        Best
                      </div>
                      <div class="col-4">{{ round['playerOne'].bestScores[0] }}</div>
                      <div class="col-4">{{ round['playerTwo'].bestScores[0] }}</div>
                    </div>
                  </q-tab-panel>

                </q-tab-panels>
              </div>
            </div>
          </div>
        </q-tab-panel>
      </q-tab-panels>
    </div>
</template>

<script>
    import Loading from "@/components/Loading/loading";
    import moment from 'moment'
    import RoundsModel from "@/components/user/Event/RoundsModel";
    import Vue from 'vue'

    export default {
        components: {RoundsModel, Loading},
        data: () => ({
            loading: true,
            mySubscriptions: [],
            round_model: false,
            target_event: null,
            round_playing: [],
            target_round_played: null,
            target_event_id: null,
            target_level: null,
            mission: null,
            competition_id: null,
            tab: 'all-events',
            scores: [],
            model: {}
        }),
        methods: {
            get_my_subscriptions() {
                this.$API.web.event.mySubscriptions()
                    .then(response => {
                        this.loading = false;
                        this.mySubscriptions = response.data;
                    }).catch(() => {
                    this.loading = false;
                })
            },
            unSubscribe(event_id) {
                this.$API.events_dashboard.cancelSubscribtions({
                    subscription_id: event_id
                })
                    .then(response => {
                        this.$q.notify({
                            message: response.data.message,
                            color: 'green'
                        });

                        this.get_my_subscriptions();

                    }).catch(() => {
                });
            },
            redirect_to_game_page() {
                if (this.target_round_played === null) {
                    this.$q.notify({
                        message: 'You can not play this round.',
                        color: 'red'
                    })
                } else {
                    let organizer_id = this.$store.getters.organizer_id,
                        user_id = this.$store.state.userData.id,
                        mission = this.mission,
                        level = this.target_level,
                        team_id = this.$store.state.userTeam[0].id,
                        event_id = this.target_event_id,
                        round = this.target_round_played,
                        role = null;


                    if (this.competition_id === 15)
                        window.location.href = `https://wro-v.com/backend/api/admin/blockly?organizer_id=${organizer_id}&id=${user_id}&mission=${mission}&level=${level}&team_id=${team_id}&event_id=${event_id}&round=${round}&role=${role}`;

                    else window.location.href = `https://wro-v.com/backend/api/admin/robot3?organizer_id=${organizer_id}&id=${user_id}&mission=${mission}&level=${level}&team_id=${team_id}&event_id=${event_id}&round=${round}&role=${role}`;
                }
            },
            toggele_model(item) {
                this.round_playing = [];
                this.target_round_played = null,
                    this.round_model = !this.round_model;
                this.target_event = item.rounds;
                this.target_event_id = item.event_id;
                this.competition_id = item.competition_id;
                this.target_level = item.level;

                let activeIdx = item.rounds.indexOf(item.rounds.find(round => round.play == '1'));
                item.rounds.map((el, index) => {
                    if (index <= activeIdx) {
                        this.round_playing.push(true);
                        this.target_round_played = el.level;
                    } else {
                        this.round_playing.push(false);
                    }
                })
            },
        },
        computed: {
            return_moment(v) {
                return moment(v).isValid();
            },
        },
        mounted() {
            this.get_my_subscriptions();

            this.$API.general.getUSerType()
                .then(response => {
                    this.mission = response[0].id - 1;
                }).catch(() => {
            });

            this.$API.general.getScores()
                .then(response => {
                    this.scores = response;
                    response.map(event => {
                        // this.model['event' + event.event_id] = 'round1'
                        Vue.set(this.model, 'event' + event.event_id, 'round1')
                    })
                })
        },
        filters: {
            event_end_time(v) {
                return moment(v).format('x');
            }
        }
    }
</script>

<style lang="scss" scoped>

    .wrapper {
        text-align: center;
        width: 824px !important;
        background: #f0f0f0 !important;
        padding: 19px 56px 45px 56px;

        p.text {
            margin-bottom: 50px !important;
            text-align: left;
        }
    }


    .Container {
        max-width: 1140px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 60px;

        &-progessbar {
            display: flex;
            width: 100%;
            padding-top: 10px;
            padding-bottom: 50px;
            counter-reset: step;


            li {
                width: calc(100% / 4);
                text-align: center;
                counter-increment: step;
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                color: #747d8c;

                &.none {
                    &::before {
                        opacity: 0;
                    }
                }

                &:before {
                    content: '';
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    height: 18px;
                    width: 18px;
                    border-radius: 50%;
                    background-color: white;
                    border: 4px solid #7C7C7C;
                    color: #747d8c;
                    font-weight: bold;
                    margin-bottom: 25px;
                    position: absolute;
                    top: 15px;
                    z-index: 88;
                }

                &:after {
                    content: '';
                    height: 4px;
                    width: 100%;
                    background-color: #7C7C7C;
                    position: absolute;
                    left: -50%;
                    top: 23px;
                    z-index: 1;
                }

                &:first-child:after {
                    display: none;
                }

                &.active:before, &.active::after {
                    color: #fff;
                    background: var(--mainColors);
                    border-color: var(--mainColors);
                    border-width: 4px;
                    position: absolute;
                    z-index: 5;
                }

                &.false:before, &.false::after {
                    background-color: #EA2027;
                    color: #fff;
                    border-color: #EA2027;
                }
            }
        }
    }

    .Medal {
        .item {
            margin-bottom: 28px;

            .the-img {
                img {
                    filter: grayscale(100);
                }
            }

            p.the-text {
                font-size: 12px;
                font-weight: bold !important;
                width: 108px;
                margin: auto !important;
                text-align: center;
            }
        }
    }

    .active_event {
        .item {
            .the-img {
                img {
                    filter: grayscale(0) !important;
                }
            }

            p.the-text {
                color: var(--mainColors);
            }
        }
    }

    .active_text {
        color: var(--mainColors) !important;
    }

    .text-details {
        font-size: 16px;
        text-align: left;
        margin: 35px 0 45px 0 !important;
    }

    .q-tabs__content--align-justify {
        .q-tab {
            flex: initial;
            padding: 0 25px;
        }
    }

</style>